import React,{useState} from 'react'



const Loader = () => {

 const [loading,setLoading] = useState()

  return (
    <div>
       <div className="flex flex-col items-center justify-center min-h-screen space-y-4">
        <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-blue-500"></div>
        <p className="text-lg text-gray-600">Loading...</p>
      </div>
    </div>
  )
}

export default Loader
